export const employeeMyTimeRequests = {
  id: "my-time-employee-requests-table",
  select: "row",
  columns: [
    {
      id: "myTimeType",
      label: "OC_TYPE",
      type: "i18nText",
      width: "120px",
    },
    {
      id: "period",
      label: "OC_PERIOD",
      type: "period",
      sort: true,
    },
    {
      id: "hours",
      type: "text",
      label: "OC_HOUR",
      align: "right",
      width: "85px",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
    },
    {
      id: "createdAt",
      type: "dateTime",
      label: "OC_REQUEST_CREATED_AT",
      width: "180px",
    },
    {
      id: "messages",
      label: "",
      align: "center",
      type: "myTimeMessageIndicator",
      width: "70px",
    },
  ],
};

export const employeeMyTimeRequestsIsMobile = {
  id: "my-time-employee-requests-table",
  select: "row",
  columns: [
    {
      id: "myTimeType",
      label: "OC_TYPE",
      type: "i18nText",
      width: "80px",
    },
    {
      id: "period",
      label: "OC_PERIOD",
      type: "period",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeAdmissions = {
  id: "my-time-employee-admissions-table",
  rowSpan: true,
  rowSpanField: "startTime",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      width: "180px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      width: "140px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "myTimeType",
      label: "MY_TIME_CATEGORY",
      type: "myTimeType",
      width: "140px",
    },
    {
      id: "timeDataTypeName",
      label: "MY_TIME_TYPE",
      type: "text",
      colorize: true,
      //width: "120px",
    },
    {
      id: "period",
      label: "OC_PERIOD",
      type: "period",
      //width: "380px",
      colorize: true,
    },
    {
      id: "myTimeActions",
      label: "",
      type: "myTimeActions",
      align: "center",
      width: "90px",
    },
  ],
};

export const employeeAdmissionsApproval = {
  id: "my-time-employee-admissions-approval-table",
  rowSpan: true,
  rowSpanField: "startTime",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      width: "180px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      width: "140px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "myTimeType",
      label: "MY_TIME_CATEGORY",
      type: "myTimeType",
      width: "140px",
    },
    {
      id: "timeDataTypeName",
      label: "MY_TIME_TYPE",
      type: "text",
      colorize: true,
      //width: "300px",
    },
    {
      id: "period",
      label: "OC_PERIOD",
      type: "period",
      //width: "380px",
      colorize: true,
    },
  ],
};

export const employeeAdmissionsApprovalIsMobile = {
  id: "my-time-employee-admissions-approval-table",
  select: "row",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeAdmissionsIsMobile = {
  id: "my-time-employee-admissions-table",
  select: "row",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeAdmissionsByAdmin = {
  id: "my-time-employee-admissions-by-admin-table",
  rowSpan: true,
  rowSpanField: "startTime",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      width: "180px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      width: "140px",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "myTimeType",
      label: "MY_TIME_CATEGORY",
      type: "myTimeType",
      width: "140px",
    },
    {
      id: "timeDataTypeName",
      label: "MY_TIME_TYPE",
      type: "text",
      colorize: true,
      //width: "120px",
    },
    {
      id: "period",
      label: "OC_PERIOD",
      type: "period",
      width: "380px",
      colorize: true,
    },
    {
      id: "myTimeAdminActions",
      label: "",
      type: "myTimeAdminAction",
      align: "center",
      width: "70px",
    },
  ],
};

export const employeeAdmissionsByAdminIsMobile = {
  id: "my-time-employee-admissions-by-admin-table",
  select: "row",
  columns: [
    {
      id: "date",
      label: "OC_DAY",
      type: "myTimeDate",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "dayType",
      label: "MY_TIME_WORK_ORDER",
      type: "dayType",
      rowSpan: true,
      colorize: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeMyTimeClosingPeriodRequest = {
  id: "my-time-employee-closing-period-request-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      width: "120px",
      align: "center",
    },
  ],
};

export const MyTimeClosingPeriodNotApproved = {
  id: "my-time-closing-period-not-approved-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "MY_TIME_MY_WORK_TIME_REPORTS",
      width: "120px",
      align: "center",
    },
  ],
};

export const MyTimeClosingPeriodNotApprovedIsMobile = {
  id: "my-time-closing-period-not-approved-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "MY_TIME_MY_WORK_TIME_REPORTS",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeMyTimeClosingPeriodRequestIsMobile = {
  id: "my-time-employee-closing-period-request-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const MyTimeClosingPeriodNotApprovedWoExaminer = {
  id: "my-time-closing-period-not-approved-wo-examiner-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_EMPLOYEE_NAME",
      search: true,
    },
    {
      id: "contractCode",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
  ],
};

export const MyTimeClosingPeriodNotApprovedWoExaminerIsMobile = {
  id: "my-time-closing-period-not-approved-wo-examiner-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_EMPLOYEE_NAME",
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const employeeWithoutMyTimeExaminerRequest = {
  id: "my-time-employee-without-examiner-request-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_EMPLOYEE_NAME",
      search: true,
    },
    {
      id: "contractCode",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      width: "120px",
      align: "center",
    },
  ],
};

export const employeeWithoutMyTimeExaminerRequestIsMobile = {
  id: "my-time-employee-without-examiner-request-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_EMPLOYEE_NAME",
      search: true,
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const allMyTimeRequests = {
  id: "my-time-all-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: true,
    },
    {
      id: "position",
      type: "text",
      label: "MY_HR_POSITION",
      sort: true,
    },
    {
      id: "requestCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      width: "120px",
      align: "center",
    },
  ],
};

export const allMyTimeRequestsIsMobile = {
  id: "my-time-all-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "requestCount",
      type: "myTimeBadges",
      label: "OC_REQUEST",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myTimeDashboardListTableDef = {
  id: "my-time-dashboard-list-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "pipedName",
      type: "pipedName",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      align: "left",
      sort: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      align: "left",
      sort: true,
    },
    {
      id: "acknowledgedAt",
      type: "acknowledgement",
      label: "MY_TIME_WORKING_SCHEDULE",
      align: "center",
    },
    {
      id: "approvedAt",
      type: "approvement",
      label: "MY_TIME_CLOSE_MONTH",
      align: "center",
    },
    {
      id: "viewWorkSchedule",
      type: "viewWorkSchedule",
      label: "OC_VIEWS",
      align: "center",
    }
  ],
};

export const myTimeDashboardListTableDefIsMobile = {
  id: "my-time-dashboard-list-table",
  select: "row",
  columns: [
    {
      id: "pipedName",
      type: "pipedName",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      align: "left",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myTimeDashboardListTableDefViewer = {
  id: "my-time-dashboard-list-table-viewer",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "pipedName",
      type: "pipedName",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      align: "left",
      sort: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      align: "left",
      sort: true,
    },
    {
      id: "viewWorkSchedule",
      type: "viewWorkSchedule",
      label: "OC_VIEWS",
      align: "center",
    },
  ],
};

export const myTimeDashboardListTableDefExaminerAuthorization = {
  id: "my-time-dashboard-list-table-authorization",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "pipedName",
      type: "pipedName",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      align: "left",
      sort: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      align: "left",
      sort: true,
    },
    {
      id: "acknowledgedAt",
      type: "acknowledgement",
      label: "MY_TIME_WORKING_SCHEDULE",
      align: "center",
    },
    {
      id: "approvedAt",
      type: "approvement",
      label: "MY_TIME_CLOSE_MONTH",
      align: "center",
    },
    {
      id: "authorizedAt",
      type: "authorization",
      label: "MY_TIME_AUTHORIZED",
      align: "center",
    },
    {
      id: "viewWorkSchedule",
      type: "viewWorkSchedule",
      label: "OC_VIEWS",
      align: "center",
    },
  ],
};

export const MyTimeClosingPeriodNotAuthorized = {
  id: "my-time-closing-period-not-authorized-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "MY_TIME_MY_WORK_TIME_REPORTS",
      width: "120px",
      align: "center",
    },
  ],
};

export const MyTimeClosingPeriodNotAuthorizedIsMobile = {
  id: "my-time-closing-period-not-authorized-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "examinerFullname",
      type: "text",
      label: "MY_HR_ROLE_EXAMINER",
      search: true,
    },
    {
      id: "recordCount",
      type: "myTimeBadges",
      label: "MY_TIME_MY_WORK_TIME_REPORTS",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

/**
 * Utility function to remove specific columns from a table definition
 * @param tableDef - The base table definition
 * @param columnIds - Array of column IDs to remove
 * @returns A new table definition without the specified columns
 *
 * @example
 * const tableDefWithoutViewing = removeColumns(myTableDef, ["viewWorkSchedule"]);
 */
export const removeColumns = (tableDef: any, columnIds: string[]) => ({
  ...tableDef,
  columns: tableDef.columns?.filter((col: any) => !columnIds.includes(col.id)),
});
